/*globals jQuery, MS, YT, mscc, awa */
( function ( $ ) {
	'use strict';

	// create new wedecs Bi object for MSR

	if ( ! window.MS || ! window.MS.wedecs ) {
		return;
	}

	window.MSR.wedecsBi = new window.MS.wedecs( {
		a    : ['[role="tab"]', '.msr-search-sidebar-anchor', '.bi-filter-list a', '.msr-expandable-section a', '.msr-toggle-more-less__trigger'],
		input: false
	} );
	// Define global object.
	if ( typeof window.MSR !== 'object' ) {
		window.MSR = {};
	}

	window.MSR.customBi = ( function () {
		var player;
		var videoContainer;
		var is_logged_in = $( 'body' ).hasClass( 'logged-in' );
		var sitesec = $( 'meta[name="ms\\.sitesec"]' ).attr( 'content' );

		var init = function () {

			//for search forms
			$( '#msr-search-form' ).each( function () {
				var $self = $( this );
				var $input = $self.find( 'input[name="s"], input[name="q"]' );
				var $submit = $self.find( 'input[type="submit"]' );
				var $selects = $self.find( 'select' );

				$selects.on( 'change', function ( e ) {
					var selected = $( this ).children( 'option:selected' );
					window.MSR.wedecsBi.sendCustomEvent( this, {
						'ms.interactionType': 16,
						'ms.title'          : selected.text(),
						'data-bi-name'      : 'filter',
					} );
				} );

				$self.on( 'submit', function ( e ) {
					window.MSR.wedecsBi.sendCustomEvent( this, {
						'ms.interactionType': 1,
						'ms.title'          : $submit.val(),
						'data-bi-name'      : 'search',
						'ms.searchtype'     : sitesec,
						'ms.searchquery'    : $input.val()
					} );
				} );
			} );

			//for events form
			$( '.msr-events-form' ).each( function () {
				var $self = $( this );
				var $selects = $self.find( 'select' );
				var $submit = $self.find( 'input[type="submit"]' );

				$selects.on( 'change', function ( e ) {
					var selected = $( this ).children( 'option:selected' );
					window.MSR.wedecsBi.sendCustomEvent( this, {
						'ms.interactionType': 16,
						'ms.title'          : selected.text(),
						'data-bi-name'      : 'filter'
					} );
				} );

				$submit.on( 'click', function ( e ) {
					var value = '';
					$selects.each( function ( i ) {
						var selected_text = $( this ).children( 'option:selected' ).text();
						if ( i > 0 ) {
							selected_text = ', ' + selected_text;
						}
						value = value + selected_text;
					} );
					window.MSR.wedecsBi.sendCustomEvent( this, {
						'ms.interactionType': 1,
						'data-bi-name'      : 'search',
						'ms.searchtype'     : sitesec,
						'ms.searchquery'    : value
					} );
				} );
			} );

			//for filters
			$( '.bi-filter-list' ).on( 'click', 'a', function () {
				window.MSR.wedecsBi.sendCustomEvent( this, {
					'ms.interactionType': 16
				} );
			} );
		};

		var registerYoutubeVideo = function () {
			videoContainer = $( document.getElementById( 'video-analytics' ) );
			if( typeof YT  !== 'undefined' && typeof YT.Player !== 'undefined' ){
				player = new YT.Player( 'video-analytics', {
					events: {
						'onStateChange': onYouTubePlayerStateChange
					}
				} );
			} else {
				window.setTimeout( registerYoutubeVideo, 500 );
			}

		};

		var onYouTubePlayerStateChange = function ( event ) {
			var vidElement = $( document.getElementById( 'video-analytics' ) );
			var wedecsBiEvent;

			if( mscc && ! mscc.hasConsent() ){
				mscc.setConsent();
			}

			switch ( event.data ) {
					case 0:
						wedecsBiEvent = window.MSR.wedecsBi.sendCustomEvent( vidElement, {
							'ms.interactionType'     : 103,
							'ms.video.completionrate': 100,
							'wcs.cn'                 : player.getVideoData().title
						} );

						break;
					case 1:
						wedecsBiEvent = window.MSR.wedecsBi.sendCustomEvent( vidElement, {
							'ms.interactionType'     : 100,
							'ms.video.completionrate': 0,
							'wcs.cn'                 : player.getVideoData().title
						} );

						break;
					case 2:
						wedecsBiEvent = window.MSR.wedecsBi.sendCustomEvent( vidElement, {
							'ms.interactionType'     : 101,
							'ms.video.completionrate': '',
							'wcs.cn'                 : player.getVideoData().title
						} );

						break;
			}
			if ( is_logged_in ) {
				console.log( wedecsBiEvent );
			}
		};

		var onAzureStateChange = function ( event ) {

			var SELF = $( document.getElementById( this.id_ ) );

			if( mscc && ! mscc.hasConsent() ){
				mscc.setConsent();
			}

			switch ( event.type ) {
					case 'ended':
						window.MSR.wedecsBi.sendCustomEvent( SELF, {
							'ms.interactionType'     : 103,
							'ms.video.completionrate': 100,
							'wcs.cn'                 : event.target.title
						} );
						break;
					case 'play':
						window.MSR.wedecsBi.sendCustomEvent( SELF, {
							'ms.interactionType'     : 100,
							'ms.video.completionrate': 0,
							'wcs.cn'                 : event.target.title
						} );
						break;
					case 'pause':
						window.MSR.wedecsBi.sendCustomEvent( SELF, {
							'ms.interactionType'     : 101,
							'ms.video.completionrate': '',
							'wcs.cn'                 : event.target.title
						} );

						break;
			}
			if ( is_logged_in ) {
				console.log( event );
			}
		};

		return {
			init                : init,
			registerYoutubeVideo: registerYoutubeVideo,
			onAzureStateChange  : onAzureStateChange
		};
	} )();

	window.MSR.customBi.init();

} )( jQuery );
